export enum EventRestrictionType {
  DEFAULT = 'DEFAULT',
  COVID = 'COVID',
  BAGS = 'BAGS',
  SOCIAL = 'SOCIAL',
  MERCHANDISE = 'MERCHANDISE',
}



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/client/src/model/event-restriction-type.ts